import {
   AfterViewInit,
   ChangeDetectorRef,
   Component,
   EventEmitter,
   Input,
   OnInit,
   Output,
   ViewChild
} from '@angular/core';
import { SettingsSectionModel } from '../model/SettingsSectionModel';
import {ClipboardService} from "../../clipboard.service";
import {ApgContextMenuComponent} from "../context-menu/apg-context-menu.component";
import {DxScrollViewComponent} from 'devextreme-angular/ui/scroll-view';


@Component({
   selector: 'ets-adjustment-grid-settings-section',
   templateUrl: './adjustment-grid-settings-section.component.html',
   styleUrls: [
      './adjustment-grid-settings-section.component.scss',
      '../adjustment-grid-common-style.scss',
   ],
})
export class AdjustmentGridSettingsSectionComponent implements OnInit, AfterViewInit {

   constructor(
       private readonly _changeDetector: ChangeDetectorRef,
       private readonly _clipboardService: ClipboardService
   ) {
   }


   @Input()
   viewModel: SettingsSectionModel;


   @Input()
   orientation: 'left' | 'right';


   @Output()
   onToggleCollapsed = new EventEmitter();


   @ViewChild(ApgContextMenuComponent)
   ctxMenu: ApgContextMenuComponent;


   @ViewChild(DxScrollViewComponent, {static: false})
   private _scrollView: DxScrollViewComponent;


   // ORION <-> APG exclusive mode (Alan 2026-09-08): while ORION holds the grid a glass covers this
   // column and swallows the wheel, but the trader must still be able to READ the settings below
   // the fold. The host forwards the glass's wheel delta here; the scroll view moves, nothing else.
   scrollBy(deltaY: number): void {
      const instance = this._scrollView ? this._scrollView.instance : null;
      if (instance) {
         instance.scrollBy(deltaY);
      }
   }


   ngOnInit(): void {

   }


   ngAfterViewInit(): void {
      this.viewModel.ctxMenu = this.ctxMenu;
   }


   toggleCollapsed() {
      if (!this.viewModel) {
         return;
      }
      this.viewModel.toggleCollapsed();
   }
}
